
<script>
  import MTableCellDefault from 'components/Data/Tables/MTable/cells/MTableCellDefault';

  export default {
    name: 'MTableCellEmpty',
    extends: MTableCellDefault,
    computed: {
      value () {
        return '';
      }
    }
  };
</script>
